/**
 * HaurakiMark — the Hauraki "seven-layer acceleration" brand mark.
 *
 * Seven nested rounded squares spiralling anticlockwise (−2° → −78°) and gaining
 * opacity as they tighten inward to a solid core with a single white spark. The
 * canonical Hauraki mark, shared across every surface and with hauraki.us.
 * Self-contained inline SVG using currentColor + per-layer opacity.
 */

/** Canonical Hauraki brand blue. */
const HAURAKI_BLUE = '#0A84FF';

type Props = {
  /** Mark height/width in px. Default 22. */
  size?: number;
  /** Override the mark colour (defaults to the Hauraki brand blue). */
  color?: string;
  className?: string;
  title?: string;
};

export function HaurakiMark({ size = 22, color = HAURAKI_BLUE, className, title = 'Hauraki' }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      className={className}
      role="img"
      aria-label={title}
    >
      <g color={color}>
        <rect x="3" y="3" width="58" height="58" rx="13" fill="currentColor" opacity="0.08" transform="rotate(-2 32 32)" />
        <rect x="7.5" y="7.5" width="49" height="49" rx="11" fill="currentColor" opacity="0.14" transform="rotate(-7 32 32)" />
        <rect x="12" y="12" width="40" height="40" rx="9" fill="currentColor" opacity="0.23" transform="rotate(-15 32 32)" />
        <rect x="16.5" y="16.5" width="31" height="31" rx="7" fill="currentColor" opacity="0.36" transform="rotate(-27 32 32)" />
        <rect x="20" y="20" width="24" height="24" rx="5.5" fill="currentColor" opacity="0.56" transform="rotate(-42 32 32)" />
        <rect x="23.5" y="23.5" width="17" height="17" rx="4" fill="currentColor" opacity="0.74" transform="rotate(-60 32 32)" />
        <g transform="rotate(-78 32 32)">
          <rect x="25.5" y="25.5" width="13" height="13" rx="3.25" fill="currentColor" />
          <circle cx="32" cy="32" r="2.35" fill="#FFFFFF" />
        </g>
      </g>
    </svg>
  );
}

export default HaurakiMark;
